import { createUseRBAC } from 'features/Auth/utils/hooks/useRBAC'

export const giftWithPurchaseAddRolesRBAC = {
  pageID: '5071dffa1503b20813981263419e7b9d',
  elementID: {
    ButtonBulkUploadProduct: 'bb502294825a9ce20f8df06db2902f92',
    ButtonAddProduct: '455bf750d885076fab2a241c5e232b66',
    ButtonSave: 'fbdd24cc35bd8d9ffb47710a2b979527',
  },
} as const

export const useRBACGiftWithPurchaseAddPage = createUseRBAC(giftWithPurchaseAddRolesRBAC.elementID)

export type UseRBACGiftWithPurchaseAddPageType = ReturnType<typeof useRBACGiftWithPurchaseAddPage>

export const giftWithPurchaseEditRolesRBAC = {
  pageID: '2b2e6aeac84ff78c120b3630f052ce09',
  elementID: {
    ViewPage: '04bbbd3a21eb55287bbded4eed721e47',
    ButtonBulkUploadProduct: 'aaebd9b5961b3670245f3abf201e83ae',
    ButtonAddProduct: 'f14e61011c0de21be56bc840fa483940',
    ButtonSave: '08b8546b86211637662541990754af8b',
  },
} as const

export const useRBACGiftWithPurchaseEditPage = createUseRBAC(
  giftWithPurchaseEditRolesRBAC.elementID,
)

export type UseRBACGiftWithPurchaseEditPageType = ReturnType<typeof useRBACGiftWithPurchaseEditPage>
